import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-carousel',
  cellSelector: '.js-carousel-slide',
  arrowShape: {
    x0: 20,
    x1: 70, y1: 40,
    x2: 70, y2: 0,
    x3: 70
  }
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const cellElements = Array.from( element.querySelectorAll( settings.cellSelector ))
  if ( cellElements.length > 1 ) {
    initCarousel( element )
  }
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initCarousel( carouselEl ) {
  const peekAdjacentSlides = getBooleanSetting( carouselEl.dataset.peekAdjacentSlides )
  const flickityOptions = {
    imagesLoaded: true,
    cellSelector: settings.cellSelector,
    pageDots: getBooleanSetting( carouselEl.dataset.pageDots ),
    prevNextButtons: getBooleanSetting( carouselEl.dataset.prevNextButtons ),
    draggable: true,
    autoPlay: false,
    pauseAutoPlayOnHover: false,
    wrapAround: true,
    arrowShape: settings.arrowShape
  }

  if ( peekAdjacentSlides ) {
    flickityOptions.cellAlign = 'center'
  }

  // eslint-disable-next-line no-unused-vars
  const carousel = new Flickity( carouselEl, flickityOptions )
}

/**
 * Parse boolean settings from data attributes.
 * @param {string} value
 * @returns {boolean}
 */
function getBooleanSetting( value ) {
  return value === 'true'
}
